import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { SlMenuItemComponent } from '../sl-menu-item/sl-menu-item.component';
import { Router } from '@angular/router';
import {
  SlDropdownInterface,
  TagColorVariants,
  TagSize,
} from '../utils/global-interfaces/sl-global.interfaces';
import { SlTagComponent } from '../sl-tag/sl-tag.component';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
import { SlButtonComponent } from '../sl-button/sl-button.component';

@Component({
  selector: 'sl-side-menu',
  standalone: true,
  imports: [
    SlMenuItemComponent,
    SlTagComponent,
    SlButtonComponent,
    SlTypographyComponent
],
  templateUrl: './sl-side-menu.component.html',
  styleUrl: './sl-side-menu.component.scss',
})
export class SlSideMenuComponent implements OnChanges {
  @Input({ required: true })
  title!: string;
  @Input()
  subtitle!: string;
  @Input()
  menuItems!: {
    label: string;
    tag?: string;
    content: {
      label: string;
      icon: string;
      url: string;
    }[];
  }[];
  @Input()
  showMenu = false;
  @Output()
  showMenuEvent = new EventEmitter<boolean>();
  @Output()
  clickTagEvent = new EventEmitter<string>();
  @Output()
  logoutClickEvent = new EventEmitter();

  tagList: string[] = [];
  selectedTagIndex = 0;
  tagColorVariants = TagColorVariants;
  tagSize = TagSize;

  ngOnChanges() {
    const allItems = this.menuItems
      .map((item) => item.content.map((cont) => cont.label))
      .flat();
    allItems.push('logout-button');
    this.tagList = allItems;
  }

  onClickTag(selectedTag: SlDropdownInterface<string>) {
    if (selectedTag.value) {
      this.clickTagEvent.emit(selectedTag.value);
    }
  }

  onKeyDownTag(event: KeyboardEvent) {
    const enter = event.key === 'Enter';
    const tab = event.key === 'Tab';
    const spc = event.key === ' ';
    const esc = event.key === 'Escape';

    if (tab) {
      if (event.shiftKey) {
        if (this.selectedTagIndex > 0) this.selectedTagIndex--;
        else this.selectedTagIndex = this.tagList.length - 1;
      } else if (this.selectedTagIndex < this.tagList.length - 1) {
        this.selectedTagIndex++;
      } else {
        this.selectedTagIndex = 0;
      }
    }
    if (spc || esc) {
      this.selectedTagIndex = 0;
      this.showMenuEvent.emit(false);
      return;
    }
    if (enter || tab) {
      return;
    }

    this.handleArrowAccessibility(event);
  }

  handleArrowAccessibility(event: KeyboardEvent) {
    const down = event.key === 'ArrowDown';
    const up = event.key === 'ArrowUp';
    event.preventDefault();
    if (down) {
      if (this.selectedTagIndex < this.tagList.length - 1) {
        document
          .getElementById(
            'sl-menu-item-' + this.tagList[++this.selectedTagIndex]
          )
          ?.focus();
      } else {
        this.selectedTagIndex = 0;
        document.getElementById('sl-menu-item-' + this.tagList[0])?.focus();
      }
    }
    if (up) {
      if (this.selectedTagIndex > 0) {
        document
          .getElementById(
            'sl-menu-item-' + this.tagList[--this.selectedTagIndex]
          )
          ?.focus();
      } else {
        this.selectedTagIndex = this.tagList.length - 1;
        document
          .getElementById(
            'sl-menu-item-' + this.tagList[this.tagList.length - 1]
          )
          ?.focus();
      }
    }
  }

  onClickLogOut() {
    this.logoutClickEvent.emit();
  }

  onKeyDownLogOut(event: KeyboardEvent) {
    event.stopPropagation();
    const down = event.key === 'ArrowDown';
    const up = event.key === 'ArrowUp';

    if (down) {
      event.preventDefault();
      this.selectedTagIndex = 0;
      document.getElementById('sl-menu-item-' + this.tagList[0])?.focus();
    }
    if (up) {
      event.preventDefault();
      document
        .getElementById('sl-menu-item-' + this.tagList[--this.selectedTagIndex])
        ?.focus();
    }
  }

  onFocusoutItems(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as Element;
    if (!relatedTarget?.id?.startsWith('sl-menu-item-')) {
      //Timeout with 0ms to guarantee that this is executed in next cycle of events and avoid console errors
      setTimeout(() => {
        this.selectedTagIndex = 0;
        this.showMenuEvent.emit(false);
      }, 0);
    }
  }

  constructor(private readonly router: Router) {}
}
